export default __webpack_public_path__ + "static/media/spreadsheet.181e1809.png";